import React from "react";
import { ArrowRight, Camera } from "lucide-react";
import SmartImage from "../../components/SmartImage";

/** Sidebar photo grid. Clicking a tile opens the shared lightbox. */
export default function GalleryRail({ images = [], onOpen, total, onViewAll }) {
  if (!images.length) return null;
  return (
    <div className="card-nq p-4" data-testid="gallery-rail">
      <p className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.16em] green-text">
        <Camera className="h-3.5 w-3.5" /> The gallery
      </p>
      <div className="mt-3 grid grid-cols-2 gap-2">
        {images.slice(0, 6).map((url, i) => (
          <button
            key={url}
            type="button"
            onClick={() => onOpen(i)}
            className="overflow-hidden rounded-lg border transition-colors duration-200 hover:border-[color:var(--nq-gold)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--nq-gold)]"
            style={{ borderColor: "rgba(255,255,255,0.08)" }}
            aria-label={`Open photo ${i + 1}`}
            data-testid="gallery-rail-item"
          >
            <SmartImage src={url} alt="" ratio="aspect-[4/3]" fit="cover" />
          </button>
        ))}
      </div>
      {total > 6 && (
        <button
          type="button"
          onClick={onViewAll}
          className="btn-outline-nq mt-3 w-full px-4 py-2 text-xs"
          data-testid="gallery-rail-view-all"
        >
          View all {total} photos <ArrowRight className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
